import { COMPONENT_VALUE_TYPES as types, COMPONENT_COLOR_THEMES,
  COMPONENT_BACKGROUND_TYPE } from 'shared/constants';

const propsSchema = [
  {
    key: 'background_type',
    label: 'Background Type',
    type: types.ENUM,
    options: COMPONENT_BACKGROUND_TYPE
  },
  {
    key: 'bg_image',
    label: 'Background Image',
    type: types.TEXT,
  },
  {
    key: 'bg_video',
    label: 'Background Video',
    type: types.OBJECT,
    children: [
      {
        key: 'video',
        label: 'Video URL',
        type: types.TEXT
      },
      {
        key: 'cover',
        label: 'Cover URL',
        type: types.TEXT
      }
    ]
  },
  {
    key: 'video_options',
    label: 'Video Options',
    type: types.OBJECT,
    children: [
      {
        key: 'loop',
        label: 'Loop',
        type: types.BOOLEAN
      },
      {
        key: 'play_on_enter',
        label: 'Start Play When Enters Viewport',
        type: types.BOOLEAN
      }
    ]
  },
  {
    key: 'title',
    label: 'Title',
    type: types.ARRAY,
    children: [
      {
        key: 'text',
        label: 'Text',
        type: types.TEXT
      }
    ]
  },
  {
    key: 'title_animation',
    label: 'Title Animation',
    type: types.BOOLEAN
  },
  {
    key: 'color_theme',
    label: 'Color Theme',
    type: types.ENUM,
    options: COMPONENT_COLOR_THEMES
  }
];

const defaultProps = {
  background_type: 'VIDEO',
  bg_image: '',
  bg_video: {
    video: 'https://genesis-cdn.ff.com/homepage/03_lidar/genesis_lidar_3mbps.mp4',
    cover: 'https://genesis-cdn.ff.com/homepage/03_lidar/lidar_cover_image.jpg'
  },
  video_options: {
    loop: false,
    play_on_enter: true
  },
  title: [
    { text: 'We endeavor to' },
    { text: 'make modern life' },
    { text: 'more connected,' },
    { text: 'more intuitive,' },
    { text: 'more effortless' }
  ],
  title_animation: true,
  color_theme: 'DARK'
};

export default {
  title: 'Full Page Side Text',
  id: 'FullPageSideText',
  propsSchema,
  defaultProps
};
